import { render, staticRenderFns } from "./BuyerExternalOrdersList.component.vue?vue&type=template&id=23ff1ea6&scoped=true&"
import script from "./BuyerExternalOrdersList.component.vue?vue&type=script&lang=js&"
export * from "./BuyerExternalOrdersList.component.vue?vue&type=script&lang=js&"
import style0 from "./BuyerExternalOrdersList.component.vue?vue&type=style&index=0&id=23ff1ea6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff1ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
